export default __webpack_public_path__ + "static/media/S_flex_1.38b56238.pdf";